/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum CnesSearchAliases {
  ACTION_NEW_SEARCH = 'action-new-search',
  AUTOCOMPLETE_PROVIDER = 'autocomplete-provider',
  CARD_CNES_SEARCH = 'card-cnes-search',
  CONTEXTUAL_BAR_0 = 'contextual-bar-0',
  DECK_CNES_SEARCH = 'deck-cnes-search',
  FETCH_CNES_SEARCH = 'fetch-cnes-search',
  FETCH_LOCATOR = 'fetch-locator',
  FETCH_MESSAGE = 'fetch-message',
  FIELD_0 = 'field-0',
  FIELD_1 = 'field-1',
  FIELD_LOCATOR = 'field-locator',
  FILTER_CNES = 'filter-cnes',
  FILTERED_LIST_0 = 'filtered-list-0',
  FORM_0 = 'form-0',
  LAYOUT_0 = 'layout-0',
  MAPPER_AUTOCOMPLETE = 'mapper-autocomplete',
  PANEL_0 = 'panel-0',
  TEXT_0 = 'text-0',
  TEXT_1 = 'text-1',
  TEXT_AUTOCOMPLETE = 'text-autocomplete',
}
export { CnesSearchAliases };
